import _ from 'lodash'
import { createSelector } from 'reselect'
import { getActiveServerId } from '../activeServer/selectors'

export const getServers = state => state.backendReducer.servers || {}
export const getServer = (state, serverId) => {
    const servers = getServers(state)
    return servers[serverId] || {}
}
export const getActiveServer = createSelector(
    [getActiveServerId, getServers],
    (active, servers) => servers[active] || {},
)
export const getActiveServerName = createSelector([getActiveServer], active => active.name || '')
// Calculated Server selectors:
export const getServerCount = createSelector([getServers], servers => _.size(servers))
export const getServerIds = createSelector([getServers], servers => Object.keys(servers))
export const getSimplifiedServers = createSelector([getServers], (servers) => {
    // No servers available
    if (_.isEmpty(servers)) return {}

    // Return a list of names:
    // { tq: 'Tranquility', sisi: 'Singularity' }
    return _.mapValues(servers, server => server.name)
})



// WEBPACK FOOTER //
// ./src/features/Backend/data/servers/selectors.js